import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'bbsf-utilities';


@Injectable()
export class AuthGuard implements CanActivate {
 public allowedPermission : number[] =[];
  constructor(private router: Router, private authService: AuthService) { 
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    debugger;
    if (await this.authService.isAuthenticated(this.allowedPermission))  
    return true;

    this.authService.setUrl(state.url)
    this.router.navigate(['/Admin/account/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
    return false;
  }

}
